/** Centralized string length limits for all user-facing Zod schemas. */

/** Short identifiers: entity names, titles, labels */
export const NAME_MAX = 200;

/** Medium text: descriptions, summaries, comments */
export const DESCRIPTION_MAX = 5_000;

/** Long-form rich text: executive summaries, GFM markdown fields */
export const RICH_TEXT_MAX = 10_000;

/** AI metric/connector context strings */
export const CONTEXT_MAX = 2_000;

/** Source attribution, relevance notes */
export const SHORT_TEXT_MAX = 1_000;

/** Chat messages (user & assistant) */
export const MESSAGE_MAX = 10_000;

/** Sealed agent notes-to-self riding on an assistant message (ciphertext, ~1.4x the plaintext cap) */
export const AGENT_NOTES_MAX = 4_000;

/** Tracking fields: paths, user agents, referrers */
export const TRACKING_MAX = 2_000;
